import React from "react";
import { Form, Input } from "antd";
import { FormattedMessage } from "react-intl";

const NewAppForm = Form.create({ name: "NewAppForm" })(function(props) {
  const { getFieldDecorator, getFieldError } = props.form;
  const appNameError = getFieldError("appName");
  const homepageError = getFieldError("homepage");
  const descriptionError = getFieldError("description");
  return (
    <Form layout="vertical">
      <Form.Item
        validateStatus={appNameError ? "error" : ""}
        help={appNameError || ""}
        label={
          <span className="customLabel">
            <FormattedMessage id="newApp_appName" />
          </span>
        }
      >
        {getFieldDecorator("appName", {
          validateTrigger: "onBlur",
          rules: [
            {
              required: true,
              message: <FormattedMessage key="tip_appNamerequired" id="tip_appNamerequired" />
            },
            {
              max: 64,
              message: <FormattedMessage key="tip_appNameMax64" id="tip_appNameMax64" />
            }
          ]
        })(<Input />)}
      </Form.Item>
      <Form.Item
        validateStatus={homepageError ? "error" : ""}
        help={homepageError || ""}
        label={
          <span className="customLabel">
            <FormattedMessage id="newApp_appServicesURL" />
          </span>
        }
        colon={false}
      >
        {getFieldDecorator("homepage", {
          validateTrigger: "onBlur",
          rules: [
            {
              max: 256,
              message: (
                <FormattedMessage key="tip_appServicesURLMax64" id="tip_appServicesURLMax64" />
              )
            },
            {
              type: "url",
              message: <FormattedMessage key="tip_URL" id="tip_URL" />
            }
          ]
        })(<Input />)}
      </Form.Item>
      <Form.Item
        validateStatus={descriptionError ? "error" : ""}
        help={descriptionError || ""}
        label={
          <span className="customLabel">
            <FormattedMessage id="newApp_desctiption" />
          </span>
        }
        colon={false}
      >
        {getFieldDecorator("description", {
          validateTrigger: "onBlur",
          rules: [
            {
              max: 1000,
              message: <FormattedMessage key="tip_descriptionMax1000" id="tip_descriptionMax1000" />
            }
          ]
        })(<Input.TextArea rows={4} />)}
      </Form.Item>
    </Form>
  );
});

export default NewAppForm;
